module.exports = __webpack_public_path__ + "img/dl-rmt-3051c-rt-family.2bb57010.png";